import React from "react";
import { newLogo } from "../../assets/Images";
import { PlayIcon, ChevronDownIcon } from "@heroicons/react/24/solid";

export default function AlbumsSection() {
  const albums = [
    { id: 1, title: "Gold Songs", active: true },
    { id: 2, title: "Lorem Ipsum", active: false },
    { id: 3, title: "Lorem Ipsum", active: false },
    { id: 4, title: "Lorem Ipsum", active: false },
    { id: 5, title: "Lorem Ipsum", active: false },
    { id: 6, title: "Lorem Ipsum", active: false },
  ];

  return (
    <div className="w-full max-w-6xl mx-auto px-6 py-12 select-none">
      <h3 className="text-2xl sm:text-3xl font-bold font-oswald text-white uppercase mb-8 border-l-4 border-secondary pl-3">
        Albums
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {albums.map((album) => {
          if (album.active) {
            return (
              <div
                key={album.id}
                className="group relative flex items-center bg-[#2A323B]/90 rounded-lg overflow-hidden border border-secondary/30 shadow-lg hover:border-secondary hover:shadow-secondary/20 transition-all duration-300 cursor-pointer h-16 sm:h-20"
              >
                {/* Left golden indicator block */}
                <div className="h-full w-14 sm:w-16 bg-secondary flex items-center justify-center text-black font-bold">
                  <ChevronDownIcon className="w-5 h-5 sm:w-6 sm:h-6 animate-pulse" />
                </div>
                {/* Text and play */}
                <div className="flex-1 px-4 flex items-center justify-between">
                  <span className="text-white font-outfit text-sm sm:text-base font-semibold tracking-wide">
                    {album.title}
                  </span>
                  <div className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-secondary group-hover:bg-secondary group-hover:text-black transition-all">
                    <PlayIcon className="w-4 h-4 translate-x-[1px]" />
                  </div>
                </div>
              </div>
            );
          }

          return (
            <div
              key={album.id}
              className="group relative flex items-center bg-[#2A323B]/70 rounded-lg overflow-hidden border border-[#2A323B]/90 hover:border-secondary/40 shadow-md hover:shadow-secondary/5 transition-all duration-300 cursor-pointer h-16 sm:h-20"
            >
              {/* Left Logo part */}
              <div className="h-full w-18 sm:w-32  flex items-center justify-center p-2.5 px-6 ">
                <img
                  src={newLogo}
                  alt="BAB Logo"
                  className="object-contain h-full w-full  group-hover:opacity-100 transition-opacity"
                />
              </div>
              {/* Text */}
              <div className="flex-1 px-4 flex items-center justify-between">
                <span className="text-gray-300 group-hover:text-white font-outfit text-sm sm:text-base font-medium tracking-wide transition-colors">
                  {album.title}
                </span>
                <span className="text-xs text-neutral-500 font-light opacity-0 group-hover:opacity-100 transition-all transform translate-x-2 group-hover:translate-x-0">
                  Play Now &rarr;
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
